import ServiceCRUD from '../../../../services/ServiceGasOrder';

class PhaseService extends ServiceCRUD {
  constructor() {
    super(`/api/fases`);
  }
}

export default new PhaseService();
